"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var unsetPathRecursively = function unsetPathRecursively(state, path) {
  path = (0, _lodash.toPath)(path);
  (0, _lodash.unset)(state, path);
  while (--path.length) {
    var val = (0, _lodash.get)(state, path);
    if (Array.isArray(val)) {
      if ((0, _lodash.every)(val, function (it) {
        return it === null || it === undefined;
      })) {
        (0, _lodash.unset)(state, path);
      }
    } else if ((0, _lodash.isEmpty)(val)) {
      (0, _lodash.unset)(state, path);
    }
  }
  return state;
};
var _default = exports["default"] = unsetPathRecursively;